import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { TourProvider } from '@reactour/tour'
import { Link, useNavigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

const steps = [
  {
    selector: '.follow-step',
    content: <div
      className={`follow-step  gap-1 rounded-xl text-gray-700 font-bold flex items-center justify-between opacity-100 pointer-events-auto `}>
      از این قسمت میتوانید کاربر را دنبال کنید. با این کار آگهی های کاربر را در صفحه خانه مشاهده میکنید
    </div>,
    position: "top",
    stepInteraction: true,
    // onClickMask : 
  },
  {
    selector: '.bookmark-step',
    content: <div
      className={`follow-step  gap-1 rounded-xl text-gray-700 font-bold flex items-center justify-between opacity-100 pointer-events-auto `}>
      با کلیک روی آیکون نشان کردن میتوان، آگهی را در قسمت
      - پروفایل
      نشان شده ها ذخیره کرد
    </div>,
    position: "top",
    stepInteraction: true,
  },
  {
    selector: '.note-step',
    content: <div
      className={`follow-step  gap-1 rounded-xl text-gray-700 font-bold flex items-center justify-between opacity-100 pointer-events-auto `}>
      با کلیک روی آیکون یادداشت میتوان برای آگهی مورد نظر یادداشت ثبت کرد که در پروفایل ذخیره میشود
    </div>,
    position: "top",
    stepInteraction: true,
  },
  {
    selector: '.comments-step',
    content: <div
      className={`follow-step  gap-1 rounded-xl text-gray-700 font-bold flex items-center justify-between opacity-100 pointer-events-auto `}>
      برای مشاهده نظرات و یا ثبت نظر روی این آیکون کلیک کنید
    </div>,
    position: "top",
    stepInteraction: true,
  },
  {
    selector: '.report-step',
    content: <div
      className={`follow-step  gap-1 rounded-xl text-gray-700 font-bold flex items-center justify-between opacity-100 pointer-events-auto `}>
      برای گزارش آگهی روی این قسمت کلیک کنید. سپس علت گزارش را انتخاب و دلیل را شرح دهید
    </div>,
    position: "top",
    stepInteraction: true,
  },
  {
    selector: '.chat-call-step',
    content: <div
      className={`follow-step  gap-1 rounded-xl text-gray-700 font-bold flex items-center justify-between opacity-100 pointer-events-auto `}>
      برای برقراری ارتباط با کاربر میتوانید از طریق چت آنلاین و یا شماره های ثبت شده اقدام کنید
    </div>,
    position: "top",
    stepInteraction: true,
  },
  {
    selector: '.view-profile-step',
    content: <div
      className={`follow-step  gap-1 rounded-xl text-gray-700 font-bold flex items-center justify-between opacity-100 pointer-events-auto `}>
      با کلیک روی نام کاربر پروفایل و اگهی های کاربر قایل مشاهده میباشند
    </div>,
    position: "top",
    stepInteraction: true,
  },
  // ...
]

const helmetContext = {};
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <HelmetProvider context={helmetContext}>
    <TourProvider steps={steps}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </TourProvider>
  </HelmetProvider>
  // </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
